import { setTerm } from './helpers';

export const setMortgageMonthlyPaymentTo = setTerm('mortgage_monthly_payment_to');
